
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getPaymentstatus = async () => {
  return await get<ApiResponse<any[]>>("/paymentstatus").then((res)=>{
      return res
    })
};

 